<template>
  <v-modal min-width="55rem" :full="!screen.breakPoint.tabPort" v-model="show" :animation="!screen.breakPoint.tabPort ? 'slide-up' : 'slide-down'" handle-click-bg>
    <template v-slot:header>{{ $t('widgets.Dashboard.configureWidget') }}</template>

    <div v-if="widget">
      <div class="text--xs-small text--uppercase text--medium text-color-grey-darken mb-2">{{ $t('widgets.Dashboard.AddWidget.settings') }}</div>
      <div class="mb-1" v-for="(setting, index) of widget.settings" :key="'setting' + index">
        <component :is="setting.component" v-bind="{ ...setting.props, value: settings[setting.settingsKey] ? settings[setting.settingsKey] : null }" v-on="{ input: (e) => handleEvent(e, setting.settingsKey) }"></component>
      </div>
    </div>

    <div class="mb-1 mt-3" v-if="widget">
      <div class="text--xs-small text--uppercase text--medium text-color-grey-darken mb-2">{{ $t('widgets.Dashboard.AddWidget.preview') }}</div>
      <component :is="widget.component" v-bind="{ ...settings, controls: false }"></component>
    </div>

    <template v-slot:footer>
      <div class="d-flex justify-end">
        <v-button @click="updateWidget()">{{ $t('widgets.Dashboard.EditWidget.save') }}</v-button>
      </div>
    </template>
  </v-modal>
</template>

<script>
import vModal from '@/ui/modals/vModal'
import vButton from '@/ui/controls/vButton'

import screen from '@/mixins/screen'
import { editingWidget } from '@/mixins/dashboardMixin'

export default {
  mixins: [screen, editingWidget],

  components: {
    vModal,
    vButton
  }
}
</script>
